import * as React from 'react';
import strings from 'owa-strings/owa-extensibility-strings';
import WebExtNotificationTypeType from 'owa-service/lib/contract/WebExtNotificationTypeType';
import { addOrReplaceNotificationMessage, removeNotificationMessage } from 'owa-addins-apis';
import { format } from 'owa-strings';
import { OsfHostContainer } from '../components/OsfHostContainer';
import 'owa-addins-osfruntime/lib/index';
import {
    AddinCommand,
    InvokeAppAddinCommandStatusCode,
    isAnyUilessAddinRunning,
    terminateUilessAddinCommand,
} from 'owa-addins-store';
import {
    AddinCommandsManifestCacheProvider,
    getNotificationTypeFromOSFInfoType,
} from 'owa-addins-osf-facade';

const styles = require('./UILessFrame.scss');

export interface UILessFrameProps {
    addinCommand: AddinCommand;
    controlId: string;
    hostItemIndex: string;
}

export interface AddinCompletedContext {
    allowEvent?: boolean;
}

export default class UILessFrame extends React.Component<UILessFrameProps, any> {
    private infoBarId: number;

    constructor(props: UILessFrameProps, context?: any) {
        super(props, context);
        this.addDisplayNotification = this.addDisplayNotification.bind(this);
        this.addGenericErrorNotification = this.addGenericErrorNotification.bind(this);
        this.invokeAppCommand = this.invokeAppCommand.bind(this);
        this.infoBarId = 0;
    }

    private addDisplayNotification(notification: OSF.Notification) {
        addOrReplaceNotificationMessage(
            this.props.hostItemIndex,
            this.props.controlId,
            false /* persistent */,
            `${this.props.addinCommand.get_Id()}${this.infoBarId++}`,
            getNotificationTypeFromOSFInfoType(notification.infoType),
            notification.description
        );
    }

    private addGenericErrorNotification() {
        const message = format(
            strings.officeAddinsNotificationGenericError,
            this.props.addinCommand.get_ExtensionDisplayName()
        );
        addOrReplaceNotificationMessage(
            this.props.hostItemIndex,
            this.props.controlId,
            false /* persistent */,
            this.props.addinCommand.get_Id(),
            WebExtNotificationTypeType.ErrorMessage,
            message,
            this.props.addinCommand.get_Size16Icon()
        );
    }

    private removeProgressNotification() {
        removeNotificationMessage(
            this.props.hostItemIndex,
            this.props.controlId,
            this.props.addinCommand.get_Id()
        );
    }

    private addProgressNotification() {
        const message = format(
            strings.officeAddinsAutomaticProgressNotificationLabel,
            this.props.addinCommand.get_ExtensionDisplayName(),
            this.props.addinCommand.get_Label()
        );
        addOrReplaceNotificationMessage(
            this.props.hostItemIndex,
            this.props.controlId,
            false /* persistent */,
            this.props.addinCommand.get_Id(),
            WebExtNotificationTypeType.ProgressIndicator,
            message
        );
    }

    private invokeAppCommand(): void {
        const control: any = this.props.addinCommand.control;
        const functionName = control.Action.FunctionName;
        const eventObj = {
            source: {
                id: control.Id,
            },
        };

        this.addProgressNotification();
        OfficeExt.AddinCommandsRuntimeManager.invokeAppCommand(
            this.props.controlId,
            functionName,
            eventObj,
            this.onEventCompleted.bind(this)
        );
    }

    private onEventCompleted(status: number, args: OSF.EventCompletedArgs) {
        this.removeProgressNotification();
        const completedContext = args ? args.completedContext : undefined;
        if (
            status != InvokeAppAddinCommandStatusCode.Success &&
            // need to check this in case the uiless has already been terminated from the MessageComposeAdapter.close() call
            isAnyUilessAddinRunning(this.props.hostItemIndex)
        ) {
            this.addGenericErrorNotification();
        }

        terminateUilessAddinCommand(
            this.props.controlId,
            this.props.hostItemIndex,
            status,
            completedContext
        );
    }

    render(): JSX.Element {
        const hostActions = {};
        hostActions[OSF.AgaveHostAction.NotifyHostError] = this.addGenericErrorNotification;

        return (
            <OsfHostContainer
                addinCommand={this.props.addinCommand}
                controlId={this.props.controlId}
                hostItemIndex={this.props.hostItemIndex}
                manifestCacheProvider={AddinCommandsManifestCacheProvider}
                onInsertOsfControl={this.invokeAppCommand}
                onDisplayNotification={this.addDisplayNotification}
                notifyHostActions={hostActions}
                className={styles.uiLessContainer}
            />
        );
    }
}
